import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // URL değiştiğinde sayfa görüntüleme olayını takip et
    const url = window.location.origin + location.pathname + location.search;
    const title = document.title;
    
    // Google Analytics'e gönder
    trackPageView(url, title);
    
    // Yandex Metrica için (eğer kullanılıyorsa)
    if (window.ym) {
      window.ym(process.env.REACT_APP_YANDEX_METRICA_ID, 'hit', url);
    }
    
  }, [location]);
};

export default usePageTracking;
